<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Foreword</p>
<p class="noindent">If you bleed wine and gold like Mr. Cavalier—and I do—then this book is for you. Call it “Cavaliers from A to Z,” or perhaps “Austin to Zydrunas.”</p>
<p class="indent"><i>The Cleveland Cavaliers: A History of the Wine &amp; Gold</i> takes you through the growing pains, when number thirty-four arrived, on through the Miracle of Richfield, when a Jim Chones broken foot stood between the Cavs and a ring. Read how World B. Free and George Karl kept basketball alive in northeast Ohio and how Wayne Embry assembled one of the best teams in the NBA during the late 1980s and early ’90s.</p>
<p class="indent">The Mike Fratello days, prior to the unforgettable King James era, earned their own place in Cavs lore as the Cavs had arguably the best team in the land for back-to-back years, only to fall short in the post-season.</p>
<p class="indent">We all believe our Cavs passion will be rewarded someday, and so to you, loyal fans, enjoy this read as we salute a real wine-and-gold winner!</p>
<p class="right1"><i>—Fred McLeod</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// for2.vue?3546d5c4